import React, {useEffect} from 'react';

export const useConsumeWheel = (ref) => {
    useEffect(() => {
        if (ref.current) {
            ref.current.addEventListener("mousewheel", onWheel);
        }
        return () => {
            if (ref.current) {
                ref.current.removeEventListener("mousewheel", onWheel);
            }
        }
    }, []);
    
    const onWheel = e => e.stopPropagation();
};
